// We export a constant object. The object reference never changes,
// so it is safe to export, but Svelte makes all its internal properties deeply reactive.
export const categoryState = $state({
  map: {},
  list: []
});

export async function initCategories() {
  // This is intended to be an async call; until it is, this function needs to
  // be truly async; so we either need to simulate a delay here, or we need to
  // resolve an empty promise.
  // await new Promise(resolve => setTimeout(resolve, 500));
  await Promise.resolve();

  categoryState.map = {
    '1': '2D Tools',
    '2': '3D Tools',
    '3': 'Shaders',
    '4': 'Materials',
    '5': 'Tools',
    '6': 'Scripts',
    '7': 'Misc',
    '8': 'Templates',
    '9': 'Projects',
    '10': 'Demos'
  };

  categoryState.list = Object.entries(categoryState.map)
    .map(([id, name]) => ({ id: String(id), name }))
    .sort((a, b) => parseInt(a.id, 10) - parseInt(b.id, 10));
}

export function getCategoryName(id) {
  if (id === null || id === undefined) {
    return 'Unknown';
  }
  return categoryState.map[String(id)] || `Cat: ${id}`;
}